import React from 'react';
import PropTypes from 'prop-types';
import colors from 'assets/styles/jsVariables/colors';
import Modal from './Modal';

function IframeModal({
  open,
  toggleModal,
  src
}) {
  return (
    <div>
      <Modal
        className="scrollIframe"
        iconFill={colors.mediumGrey}
        paperStyle={{
          maxWidth: 478, width: '100%', overflowY: 'inherit'
        }}
        titleContainerStyle={{
          backgroundColor: colors.background,
        }}
        childrenStyle={{
          padding: 0, margin: '0 0 -20px 0', backgroundColor: colors.background, overflowY: 'inherit'
        }}
        open={open}
        title=""
        modal
        toggleModal={toggleModal}
        bodyStyle={{ padding: 0 }}
        contentStyle={{ maxWidth: 479 }}
      >
        <div style={{ overflowX: 'auto' }}>
          <iframe
            title="iframeModal"
            src={src}
            scrolling="yes"
            width="100%"
            height="480px"
            frameBorder="0"
          />
        </div>
      </Modal>
    </div>
  );
}

IframeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  src: PropTypes.string
};
IframeModal.defaultProps = {
  src: ''
};

export default IframeModal;



// WEBPACK FOOTER //
// ./src/components/Modal/IframeModal.jsx